import { MultiSelect } from "@/components/ui/multi-select";
import { User } from "@/lib/api/user";
import { useUpdateUser } from "@/lib/hooks/user/use-update-user";

interface MeasurementsProps {
  user: User;
}

export function Measurements({ user }: MeasurementsProps) {
  const { handleUpdate } = useUpdateUser({
    userId: user.id,
    metadata: {
      onboarding: {
        mental_health_issues:
          user?.metadata?.onboarding?.mental_health_issues || [],
      },
    },
  });

  return (
    <div>
      <h3 className="mb-2 text-sm font-medium text-neutral-500">
        Current survey
      </h3>
      <MultiSelect
        options={[
          { value: "depression", label: "Depression (PHQ)" },
          { value: "anxiety", label: "Anxiety (GAD)" },
          { value: "general", label: "General (WHO)" },
        ]}
        defaultValue={(
          user?.metadata?.onboarding?.mental_health_issues || []
        ).map((issue) => ({
          value: issue,
          label: issue.charAt(0).toUpperCase() + issue.slice(1),
        }))}
        onChange={(selectedOptions) => {
          const currentMetadata = user?.metadata || {};
          const currentOnboarding = currentMetadata.onboarding || {};

          handleUpdate("metadata", {
            ...currentMetadata,
            onboarding: {
              ...currentOnboarding,
              mental_health_issues: selectedOptions.map(
                (option) => option.value,
              ),
            },
          });
        }}
        placeholder="Select mental health issues..."
      />
    </div>
  );
}
